import React, { useState } from "react";
import { ViewTicket } from './actionButtons/ViewTicket';
import { ConfirmDeleteOrganizationTicket } from './actionButtons/ConfirmDeleteOrganizationTicket';
import {
  TICKET_TYPES,
  TRANSLATED_TICKET_TYPES,
  TRANSLATED_TICKETS_STATUSES,
  TRANSLATED_TICKETS_SUBJECTS,
  TICKETS_STATUSES,
  TRANSLATED_TICKET_PRODUCT_REFERENCES
} from '../../../../config/constants';
import { RejectTicket } from './actionButtons/RejectTicket';
import {ConfirmContactTicket} from "./actionButtons/ConfirmContactTicket";
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import classnames from "classnames";
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from 'react-intl';
import { NoRows } from "../../../layout/Table/NoRows";

function TableRow(props) {
  const { ticket, index } = props;
  const [ toggle, setToggle ] = useState( false );

  if (! ticket) {
    return null;
  }

  const renderActionButtons = () => {
    const contactFormTicketTypes = [
      TICKET_TYPES.CONTACT_ISSUES, TICKET_TYPES.CONTACT_COMMERCIAL, TICKET_TYPES.CONTACT_OTHERS
    ];

    const neoTicketTypes = [
      TICKET_TYPES.NEO_IMPORT_CLIENT, TICKET_TYPES.NEO_IMPORT_ORDER, TICKET_TYPES.NEO_IMPORT_RECEIPT
    ];

    const packageTicketTypes = [
      TICKET_TYPES.CLONE_PACKAGE, TICKET_TYPES.PACKAGE_EMAIL_NOTIFICATION
    ];

    if (ticket.type === TICKET_TYPES.DELETE_ORGANIZATION) {
      return (
        <>
          <ViewTicket
            ticket={ticket}
            index={index}
          />
          <ConfirmDeleteOrganizationTicket
            ticket={ticket}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback(true)}
          />
          <RejectTicket
            ticket={ticket}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback( true )}
          />
        </>
      )
    }

    if (contactFormTicketTypes.indexOf(ticket.type) !== -1 ||
      neoTicketTypes.indexOf(ticket.type) !== -1 ||
      packageTicketTypes.indexOf(ticket.type) !== -1
    ) {
      return (
        <>
          <ViewTicket
            ticket={ticket}
            index={index}
          />
          <ConfirmContactTicket
            ticket={ticket}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback( true )}
          />
          <RejectTicket
            ticket={ticket}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback( true )}
          />
        </>
      )
    }
  }

  const toggleRow = () => {
    setToggle( ! toggle )
  }

  const renderTicketMessage = () => {
    if (! ticket.message) {
      return <NoRows colSpan="12"/>;
    }

    return (
      <tr>
        <td></td>
        <td colSpan="10" className="td-overflow-tickets tickets-list-message">{ticket.message}</td>
        <td></td>
      </tr>
    );
  }

  return (
    <>
      <tr>
        <td>
          <Link
            to="#"
            id={`expand-collapse-documents-${ticket.id}`}
            className="cursor-pointer mr-2 link-icon-color"
            onClick={() => toggleRow()}
          >
            <FontAwesomeIcon
              size="lg"
              className="mr-2 cursor-pointer"
              pointerEvents="none"
              icon={toggle ? faMinus : faPlus}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`expand-collapse-documents-${ticket.id}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            {
              toggle ? <FormattedMessage id="components.pages.ticket.table.table_row.collapse_message"/> :
                <FormattedMessage id="components.pages.ticket.table.table_row.expand_message"/>
            }
          </UncontrolledTooltip>
        </td>
        <td>{ticket.number}</td>
        <td>{moment(ticket.created_at).format('LLL')}</td>
        <td>
          <FontAwesomeIcon
              size="xs"
              className={
                classnames(
                  "mr-3",
                  {
                    "text-success": ticket.status === TICKETS_STATUSES.NEW,
                    "text-primary": [
                      TICKETS_STATUSES.APPROVED,
                      TICKETS_STATUSES.SOLVED,
                    ].indexOf(ticket.status) !== -1,
                    "text-warning": [
                      TICKETS_STATUSES.IN_PROGRESS,
                      TICKETS_STATUSES.WAITING_RESPONSE,
                    ].indexOf(ticket.status) !== -1,
                    "text-danger": [
                      TICKETS_STATUSES.ERROR_ON_JOB,
                      TICKETS_STATUSES.REJECTED,
                    ].indexOf(ticket.status) !== -1,
                  }
                )
              }
              icon={ faCircle }
          />
          {TRANSLATED_TICKETS_STATUSES[ticket.status]}
        </td>
        <td>{ticket.organization ? ticket.organization.name : ticket.organization_name}</td>
        <td>{ticket.organization ? `${ticket.user.first_name} ${ticket.user.last_name}` : ticket.full_name}</td>
        <td>{ticket.email ? ticket.email : '-'}</td>
        <td>{TRANSLATED_TICKETS_SUBJECTS[ticket.subject]}</td>
        <td>{TRANSLATED_TICKET_TYPES[ticket.type]}</td>
        <td className="td-overflow-tickets">{ticket.reason}</td>
        <td>{TRANSLATED_TICKET_PRODUCT_REFERENCES[ticket.product_reference]}</td>
        <td className="w-10">
          { renderActionButtons() }
        </td>
      </tr>
      {
        toggle && renderTicketMessage()
      }
    </>
  );
}

TableRow.defaultProps = {
  user: null,
};

export { TableRow };
